import { IMicrofrontendsAPI } from '../../../shared/types/microfrontends/types';
import { openAuthModal } from '../../repositories/header-frontend/v3/open-auth-modal/helpers';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: {
      openAuthModal,
    },
  };
}
